import {
  SAVE_AUTHORIZATION,
  CLEAR_AUTHORIZATION,
} from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case SAVE_AUTHORIZATION:
      return { ...state, authToken: action.token, role: action.role };
    case CLEAR_AUTHORIZATION:
      return { ...state, authToken: '', role: '' };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authorization-reducer.js